import { useCallback, useEffect, useRef } from 'react';

/**
 * A React hook to handle setTimeout and clearTimeout easily.
 */
export function useTimeout() {
  const timeoutId = useRef<ReturnType<typeof setTimeout> | null>(null);

  // Clear timeout on unmount
  useEffect(() => {
    return () => {
      if (timeoutId.current) {
        clearTimeout(timeoutId.current);
      }
    };
  }, []);

  const set = useCallback((callback: () => void, delay: number) => {
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(callback, delay);
  }, []);

  const clear = useCallback(() => {
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
      timeoutId.current = null;
    }
  }, []);

  return { set, clear };
}
